import React from "react";
import {Container, Row} from "reactstrap";
import $ from "jquery";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../Calendar/Calendar.css";
import Register from "../Calendar/Register";
import BigCalendar from "react-big-calendar";
import moment from "moment";
import axios from 'axios'
import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faTimes,
    faCheck,
    faChevronLeft,
    faChevronRight,
    faClock
} from "@fortawesome/free-solid-svg-icons";

library.add(faTimes, faCheck, faChevronLeft, faChevronRight, faClock);
const localizer = BigCalendar.momentLocalizer(moment);


function Events({event}) {
    return (
        <div id="selectme">
      <span id={event.id}>
         {event.venue}
      </span>
        </div>
    );
}

const CustomToolbar = toolbar => {
    const goToBack = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() - 1);
        toolbar.onNavigate("prev");
    };

    const goToNext = () => {
        toolbar.date.setMonth(toolbar.date.getMonth() + 1);
        toolbar.onNavigate("next");
    };

    const label = () => {
        const date = moment(toolbar.date);
        return (
            <span className="tb-month">
        {date.format("MMMM")}
                <span className="tb-Year"> / {date.format("YYYY")}</span>
      </span>
        );
    };

    return (
        <div className="toolbar-container">
            <label className="label-date">{label()}</label>

            <div className="back-next-buttons">
                <button className="btn-back btn-calendar" onClick={goToBack}>
                    <FontAwesomeIcon className="oi" icon="chevron-left"/>
                </button>
                <button className="btn-next btn-calendar" onClick={goToNext}>
                    <FontAwesomeIcon className="oi" icon="chevron-right"/>
                </button>
            </div>
        </div>
    );
};

const getOffset = (el) => {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
}

export default class Calendar extends React.Component {

    constructor(props) {

        super(props);
        //console.log(this.props)
        this.state = {
            tooltipOpen: false,
            CalenderEvents: "",
            formEvent: {
                id: "",
                title: "",
                venue: "",
                time: "",
                desc: "",
                price: "",
                date: "",
                start_time: "",
                end_time: "",
            }
        };

        this.tooltip = this.tooltip.bind(this);
        this.toggle1 = this.toggle1.bind(this);
        this.shareWithForm = this.shareWithForm.bind(this);
    }

    tooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    toggle1(event) {
        this.shareWithForm(event);

        setTimeout(function () {

            var d = document.getElementById("popupss");
            var btn = document.getElementsByClassName("rbc-selected")[0];
            var offset = getOffset(btn);

            d.style.position = "absolute";
            d.style.display = "block";
            d.style.left = offset.left + 45 + "px";
            d.style.top = offset.top + "px";
            d.style.background = "#0E121A";
            d.style.border = "1px solid #282D36";
            d.style.padding = "15px 25px";
        }, 10);

    }

    shareWithForm(event) {
        var {formEvent} = this.state;
        formEvent.id = event.id;
        formEvent.title = event.title;
        formEvent.time = event.time;
        formEvent.desc = event.desc;
        formEvent.price = event.price;
        formEvent.date = event.start;
        formEvent.start_time = event.start_time;
        formEvent.end_time = event.end_time;
        formEvent.apply_url = event.apply_url;
        this.setState({
            formEvent
        });
    }

    componentDidMount() {

        var communityEvents = [];
        var certificateEvents = [];
        $("body").on("click", function () {
            $("#popupss").hide();
        });

        //get certificate events
        axios.get('/events')
            .then(response => {
                let appointments = response.data;
                //var events = [];

                for (let i = 0; i < appointments.length; i++) {
                    let title = appointments[i].title;
                    let desc = appointments[i].description;
                    let price = appointments[i].price;
                    let event_type = 'certification-session';
                    let time = moment(appointments[i].start_time).format("HH:mm") + " - " + moment(appointments[i].end_time).format("HH:mm");
                    communityEvents[i] = {
                        start: new Date(appointments[i].date),
                        end: new Date(appointments[i].date),
                        selectable: true,
                        number: i + 1,
                        title: title,
                        desc: desc,
                        price: price,
                        time: time,
                        id: appointments[i].id,
                        start_time: appointments[i].start_time,
                        end_time: appointments[i].end_time,
                        event_type: event_type,
                        venue: appointments[i].venue
                    }
                }
                this.setState({
                    CalenderEvents: communityEvents.concat(certificateEvents)
                })
            })
            .catch(function (error) {
                console.log(error);
            });

        //get community events
        axios.get('/marketing-events')
            .then(response => {
                let appointments = response.data;
                for (let i = 0; i < appointments.length; i++) {
                    const title = appointments[i].title;
                    const desc = appointments[i].description;
                    const price = appointments[i].price;
                    const event_type = 'marketing-event';
                    const time = moment(appointments[i].start_time).format("HH:mm") + " - " + moment(appointments[i].end_time).format("HH:mm");
                    certificateEvents[i] = {
                        start: new Date(appointments[i].date),
                        end: new Date(appointments[i].date),
                        selectable: true,
                        number: i + 1,
                        title: title,
                        desc: desc,
                        price: price,
                        time: time,
                        id: appointments[i].id,
                        start_time: appointments[i].start_time,
                        end_time: appointments[i].end_time,
                        event_type: event_type,
                        venue: appointments[i].venue,
                        apply_url: appointments[i].apply_url
                    }
                }
//              let events = communityEvents.concat(certificateEvents).filter(isDateInFuture);
                this.setState({
                  CalenderEvents: communityEvents.concat(certificateEvents)
                })

            })
            .catch(function (error) {
                console.log(error);
            });
    }


    render() {

        const {CalenderEvents} = this.state;
        return (
            <Container className="calendar-block">
                <h3 className="text-center" id="getcertified">
                    {this.props.title}
                </h3>
                <Row className="outerCatg">
                    <div className="eventsCategory">
                        <div className="community">Community Events</div>
                        <div className="certification">Certification Sessions</div>
                    </div>
                    {this.state && this.state.CalenderEvents &&
                        <BigCalendar
                            localizer={localizer}
                            events={CalenderEvents}
                            timeslots={4}
                            components={{
                                toolbar: CustomToolbar,
                                event: Events
                            }}
                            className="calender-wrapper"
                            onSelectEvent={this.toggle1}
                            views={["month"]}
                            eventPropGetter={event => ({className: 'category-' + event.event_type})}
                        />
                    }
                </Row>
                <Register getEvent={this.state.formEvent}/>
            </Container>
        );
    }
}
